

export default class RewardTranslationsUpdateRequest  {
	LangCode?: string = '';
	Name?: string = '';
	Description?: string = '';
	constructor(obj?: Partial<RewardTranslationsUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
